import { Grid, Typography, Box, Stack, FormControl, InputLabel, Select, MenuItem, TextField, InputAdornment, IconButton } from "@mui/material";
import { useForm } from "../../../../providers/FormProvider";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import { MissionEnums, MissionEnumsLists } from "../../../../common/constants";
import { Search as SearchIcon } from "@mui/icons-material";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%"
    },
    referencedCustomer: {
      position: "relative",
      width: "100%",
      padding: theme.spacing(1.5),
      borderRadius: theme.spacing(1),
      background: "#EFF6FF",
      border: `1px solid #BEDBFF`,
      minHeight: "100%",
      userSelect: "none",
      cursor: "default",
      color: "#1C5DBD"
    }
  })
);

export default function TargetSection() {
  const { classes } = useStyles();
  const {
    targetType,
    setTargetType,
    targetDescription,
    setTargetDescription,
    locked,
  } = useForm();
  const { t } = useTranslation();


  return (
    <Stack className={classes.root} spacing={1}>

      <Typography variant="h6">
        {t("advancedForm:targetSection:title")}
      </Typography>

      <Box>
        <Grid container spacing={1} alignItems="space-between">

          <Grid item xs={12}>
            <FormControl fullWidth size="small" variant="filled">
              <InputLabel>{t("advancedForm:targetSection:targetType")}</InputLabel>
              <Select value={targetType} onChange={ev => setTargetType(ev.target.value)} disabled={locked}>
                {MissionEnumsLists.TargetType.map((type, value) => <MenuItem value={value} key={value}>{t(`enums:targetType:${type}`)}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>

          {
            targetType === MissionEnums.TargetType.Car ? (
              <CarDetails />
            ) : targetType === MissionEnums.TargetType.Boat ? (
              <BoatDetails />
            ) : null
          }

          <Grid item xs={12}>
            <TextField
              label={t("advancedForm:targetSection:details")}
              variant="filled"
              value={targetDescription}
              onChange={ev => setTargetDescription(ev.target.value)}
              fullWidth
              size="small"
              multiline
              minRows={2}
              disabled={locked}
            />
          </Grid>



        </Grid>
      </Box>


    </Stack >
  );
}


function CarDetails() {
  const { t } = useTranslation();

  const {
    make,
    setMake,
    model,
    setModel,
    registration,
    setRegistration,
    fetchRegistrationData,
    locked,
  } = useForm();


  return (
    <>
      <Grid item xs={12}>
        <TextField
          label={t("advancedForm:targetSection:registration")}
          variant="filled"
          value={registration}
          onChange={ev => setRegistration(ev.target.value)}
          fullWidth
          size="small"
          disabled={locked}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={fetchRegistrationData} disabled={!registration}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              )
            }
          }}
        />
      </Grid>

      <Grid item xs={12} lg={6}>
        <TextField
          label={t("advancedForm:targetSection:make")}
          variant="filled"
          value={make}
          onChange={ev => setMake(ev.target.value)}
          fullWidth
          size="small"
          disabled={locked}
        />
      </Grid>

      <Grid item xs={12} lg={6}>
        <TextField
          label={t("advancedForm:targetSection:model")}
          variant="filled"
          value={model}
          onChange={ev => setModel(ev.target.value)}
          fullWidth
          size="small"
          disabled={locked}
        />
      </Grid>

    </>
  );
}


function BoatDetails() {
  const { t } = useTranslation();

  const {
    locked,
    make,
    setMake,
    model,
    setModel,
    registration,
    setRegistration,
  } = useForm();

  return (
    <>
      <Grid item xs={12}>
        <TextField
          label={t("advancedForm:targetSection:registration")}
          variant="filled"
          value={registration}
          onChange={ev => setRegistration(ev.target.value)}
          fullWidth
          size="small"
          disabled={locked}
        />
      </Grid>

      <Grid item xs={12} lg={6}>
        <TextField
          label={t("advancedForm:targetSection:make")}
          variant="filled"
          value={make}
          onChange={ev => setMake(ev.target.value)}
          fullWidth
          size="small"
          disabled={locked}
        />
      </Grid>

      <Grid item xs={12} lg={6}>
        <TextField
          label={t("advancedForm:targetSection:model")}
          variant="filled"
          value={model}
          onChange={ev => setModel(ev.target.value)}
          fullWidth
          size="small"
          disabled={locked}
        />
      </Grid>
    </>
  );
}

